import React, { useState } from "react";
import PropTypes from "prop-types";

import { Fieldset } from "rbx";
import { useMutation } from "react-apollo";
import { EditFormButtonGroup } from "../inputs";

import Section from "../Section";

import {
  UPDATE_USER_MUTATION,
  DELETE_USER_MUTATION
} from "../../graphql/Users/Users.graphql";

import { ourToast as toast } from "../../utils";

import UserForm from "./UserForm";

const INITIAL_STATE = {
  UserId: "",
  Password: "",
  FirstName: "",
  MiddleName: "",
  LastName: "",
  Active: true,
  CompanyId: localStorage.getItem("user_company") || "",
  FromEmployee: false
};
const EditUserForm = ({ user, onComplete }) => {
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE,
    ...user,
    ConfirmPassword: ""
  });
  const [updateUser, { loading }] = useMutation(UPDATE_USER_MUTATION, {
    refetchQueries: ["ALL_USERS_QUERY", "SINGLE_USER_QUERY"]
  });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  return (
    <Section title="Edit User">
      <form
        id={`edit-user-form-${user.RecId}`}
        onSubmit={async e => {
          e.preventDefault();
          const obj = Object.keys(INITIAL_STATE).reduce(
            (acc, curr) =>
              inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
            {}
          );
          try {
            if (obj.Password !== inputs.ConfirmPassword) {
              throw new Error("Passwords must match. Try again.");
            }
            await updateUser({
              variables: {
                data: { ...obj },
                where: { RecId: parseInt(user.RecId) }
              }
            });
            onComplete();
            toast.success("User edited successfully.");
          } catch (err) {
            toast.error("Error editing User.");
          }
        }}
      >
        <Fieldset disabled={loading}>
          <UserForm
            inputs={inputs}
            passwordRequired={false}
            onChange={handleChange}
          />
          <EditFormButtonGroup
            deleteMutation={DELETE_USER_MUTATION}
            form={`edit-user-form-${user.RecId}`}
            refetchQueries={["ALL_USERS_QUERY"]}
            variables={{ where: { RecId: user.RecId } }}
            onComplete={onComplete}
          />
        </Fieldset>
      </form>
    </Section>
  );
};
EditUserForm.propTypes = {
  onComplete: PropTypes.func,
  user: PropTypes.object
};
export default EditUserForm;
